import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RenegotiationResumePageComponent } from './renegotiation-resume-page/renegotiation-resume-page.component';
import { MaterialAngularModule } from '../material-design/material.module';
import { BrowserModule } from '@angular/platform-browser';
import { ComponentsModule } from '../shared/components/components.module';
import { SharedDirectivesModule } from '../shared/directives/shared-directives.module';
import { FormsModule } from '@angular/forms';

@NgModule({
  declarations: [RenegotiationResumePageComponent],
  imports: [
    CommonModule,
    ComponentsModule,
    BrowserModule,
    MaterialAngularModule,
    SharedDirectivesModule,
    FormsModule
  ]
})
export class RenegotiationResumeModule { }
